/** Admin routes shared by the legacy app, Next.js SDKs and render logging. */
export function isAdminPath(path: string): boolean {
  return /^\/(?:(?:en|fr|us)\/)?(?:spaces\/admin|admin)(?:\/|\?|$)/u.test(path);
}

export function getAdminRequestHeaders(frontendUrl: string): Record<string, string> {
  if (!frontendUrl) return {};
  const path = new URL(frontendUrl, 'http://localhost').pathname;
  return isAdminPath(path) ? { 'X-OC-Admin-Url': frontendUrl } : {};
}
